import type { ReactNode } from 'react';
import { Avatar, type AvatarProperties } from '../avatar';
import { Col } from '../col';
import { Row } from '../row';
import { Text, type TextProperties } from '../typography';

export type EntitySnippetProperties = {
  avatarProps?: AvatarProperties;
  descriptionProps?: TextProperties;
  extra?: ReactNode;
  titleProps: TextProperties;
  wrapAvatar?: (avatar: ReactNode) => ReactNode;
  wrapTitle?: (title: ReactNode) => ReactNode;
};

// TODO: move to react-components
const EntitySnippet = ({
  avatarProps,
  descriptionProps,
  extra,
  titleProps,
  wrapAvatar,
  wrapTitle,
}: EntitySnippetProperties) => {
  const avatar = avatarProps ? <Avatar size="small" {...avatarProps} /> : null;
  const title = <Text type="title" {...titleProps} />;

  return (
    <Row align="middle" gutter={['xs', 0]} wrap={false}>
      {avatar ? <Col>{wrapAvatar ? wrapAvatar(avatar) : avatar}</Col> : null}
      <Col flex="auto">
        {wrapTitle ? wrapTitle(title) : title}
        {descriptionProps ? (
          <div>
            <Text
              ellipsis={{ tooltip: descriptionProps.children }}
              size="small"
              type="secondary"
              {...descriptionProps}
            />
          </div>
        ) : null}
      </Col>
      {extra ? <Col>{extra}</Col> : null}
    </Row>
  );
};

export default EntitySnippet;
